import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@core/index";
import { IGetAllInvoiceParties } from "../utils/types";
import { apiEndpoint } from "../utils/constants";
import { enqueueSnackbar } from "notistack";
import { IInvoiceRow } from "../utils/types";
import { buildQueryParams } from "@shared/utils/functions";

export type InvoicePartiesListResponse = {
  data: IInvoiceRow[];
  pagination: {
    total: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  };
};

export const useGetAllInvoiceParties = (config: IGetAllInvoiceParties) => {
  return useQuery<
    InvoicePartiesListResponse,
    Error,
    InvoicePartiesListResponse,
    (string | boolean | undefined)[]
  >({
    queryKey: [
      "invoiceParties",
      config.data.pageNumber,
      config.data.pageSize,
      config.data.includeInactive,
      config.data.searchQuery ?? "",
      config.data.orderBy ?? "",
      config.data.order ?? "",
      config.data.updatedSince ?? "",
    ],
    queryFn: async () => {
      const queryString = buildQueryParams(config.data);

      const url = `${apiEndpoint}?${queryString}`;

      try {
        const data = await apiFetch<InvoicePartiesListResponse>(url);
        return data;
      } catch (error) {
        const message =
          error instanceof Error
            ? error.message
            : "Failed to fetch the Invoice Parties List.";

        enqueueSnackbar(message, {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        });
        throw error;
      }
    },

    placeholderData: (prev) => prev,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};
